import gql from 'graphql-tag';

export default gql`
  mutation signup($user: SignupInput!) {
    signup(user: $user) {
      id
      username
      authToken
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/signup.mutation.js